export enum PromoCodeEvent {
  PROMO_CODE_APPLIED = 'PromocodeApplied',
}
